'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var styled = require('styled-components');
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = require('@narvar/nth-bit-paragraph');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../../../common/components/Icon/index.js');
var ConfirmationViewRoot = require('../../../../common/views/Confirmation/ConfirmationViewRoot.js');
var ConfirmationProvider = require('../../../../common/views/Confirmation/ConfirmationProvider.js');
var ViewWrapper = require('../../components/ViewWrapper.js');
var AgentNavigatorProvider = require('../../providers/AgentNavigatorProvider.js');
var IframeHeight = require('../../components/IframeHeight.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);

const Container = styled__default["default"].div.withConfig({
  componentId: "sc-1lmwo31-0"
})(["display:flex;flex-direction:column;align-items:center;text-align:center;"]);
const Spacer = styled__default["default"].div.withConfig({
  componentId: "sc-1lmwo31-1"
})(["padding-bottom:1rem;"]);
const Confirmation = () => {
  const {
    claimsConfirmationTitle,
    claimsConfirmationDescription,
    claimsConfirmationButton
  } = nthHookTranslations.useTranslations();
  const {
    navigateToOrderOverview
  } = AgentNavigatorProvider.useAgentNavigator();
  const {
    email
  } = ConfirmationProvider.useConfirmation();
  return /*#__PURE__*/React__default["default"].createElement(ViewWrapper["default"], {
    dismissButton: {
      onClick: () => navigateToOrderOverview()
    },
    bottomButton: {
      children: claimsConfirmationButton,
      onClick: () => navigateToOrderOverview()
    }
  }, /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(index.IconThemed, {
    icon: "CheckMarkCircleOutlined"
  })), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, null, claimsConfirmationTitle), /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, mustache__default["default"].render(claimsConfirmationDescription ?? '', {
    email
  })))));
};
const ConfirmationWithProviders = nthHookTranslations.withTranslationsProvider(Confirmation, {
  translationKeys: ['claimsConfirmationTitle', 'claimsConfirmationDescription', 'claimsConfirmationButton']
});
const ConfirmationWithViewRoot = () => {
  return /*#__PURE__*/React__default["default"].createElement(IframeHeight["default"], null, /*#__PURE__*/React__default["default"].createElement(ConfirmationViewRoot["default"], null, /*#__PURE__*/React__default["default"].createElement(ConfirmationWithProviders, null)));
};

exports["default"] = ConfirmationWithViewRoot;
